import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "my-[2.5%] text-xl font-medium" }
const _hoisted_2 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_3 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}
const _hoisted_4 = { class: "my-[2.5%] text-xl font-medium" }
const _hoisted_5 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_6 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}
const _hoisted_7 = { class: "my-[2.5%] text-xl font-medium" }
const _hoisted_8 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_9 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}
const _hoisted_10 = { class: "my-[2.5%] text-xl font-medium" }
const _hoisted_11 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_12 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}

import { ref, computed, Ref, ComputedRef, WritableComputedRef } from 'vue'
    import useContactStore from '@/utils/useContactStore'
    import FullButton from '@/components/Buttons/FullButton.vue'
    import router from '@/router'
    import { FormWithValidation } from '@/model/types'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ContactsForm',
  setup(__props) {

    const { loading, selectedContact, createContact, updateContact } = useContactStore()

    // I tried refactoring this code to use a single object for the form fields, but failed
    // When refactoring, feel free to use the "./TheContactsForm.json" file as a building block
    // I'll leave this code as is for now because it's working, but it's a mess

    const rules = {
        required: (value: any) => !!value || 'Required',
        number: (value: string) => /^[\d]*$/.test(value) || 'Value should be a number',
        gender: (value: string) => ['M', 'F', 'NA'].includes(value) || 'Should be M, F, or NA',
        email: (value: string) => /.+@.+\..+/.test(value) || 'E-mail must be valid',
        zipCode: (value: string) => /^[\d]{4,5}$/.test(value) || 'ZIP code must be 4 or 5 digits',
        maxLength: (value: string | any[]) => value.length <= 250 || 'Input exceeds maximum length',
        maxLength80: (value: string | any[]) =>
            value.length <= 80 || 'Input exceeds maximum length',
        maxLength65535: (value: string | any[]) =>
            value.length <= 65535 || 'Input exceeds maximum length',
        validDate: (value: string | number | Date) => {
            const pattern = /^\d{4}-\d{2}-\d{2}$/
            if (typeof value === 'string' && !value.match(pattern)) {
                return 'Date must be in YYYY-MM-DD format'
            }

            const date = new Date(value)
            const dateParts = (value as string).split('-')
            const year = parseInt(dateParts[0], 10)
            const month = parseInt(dateParts[1], 10) - 1
            const day = parseInt(dateParts[2], 10)

            // Check if the date is valid
            if (
                date.getFullYear() !== year ||
                date.getMonth() !== month ||
                date.getDate() !== day
            ) {
                return 'Invalid date'
            }

            // Check if the date is not in the future
            const today = new Date()
            if (date > today) {
                return 'Date must not be in the future'
            }

            return true
        },
        bankId: (value: string) => /^[0-9]+$/.test(value) || 'Value should be a number',
    }

    // form fields
    // todo: split this mess into components, maybe use a json schema form library

    let localContactId = ref(selectedContact.value?.contactId || '')

    let localPersonTitle = ref(selectedContact.value?.person?.title || '')
    let localPersonTitleDescription = ref(selectedContact.value?.person?.titleDescription || '')
    let localPersonGender = ref(selectedContact.value?.person?.gender || '')
    let localPersonGreeting = ref(selectedContact.value?.person?.greeting || '')
    let localPersonFirstName = ref(selectedContact.value?.person?.firstName || '')
    let localPersonSecondName = ref(selectedContact.value?.person?.secondName || '')
    let localPersonFamilyName = ref(selectedContact.value?.person?.familyName || '')
    let localPersonBirthDate = ref(selectedContact.value?.person?.birthDate || '')
    let localPersonDepartment = ref(selectedContact.value?.person?.department || '')
    let localPersonStreetName = ref(selectedContact.value?.person?.streetName || '')
    let localPersonStreetNumber = ref(selectedContact.value?.person?.streetNumber || '')
    let localPersonPoBox = ref(selectedContact.value?.person?.poBox || '')
    let localPersonZip = ref(selectedContact.value?.person?.zip || '')
    let localPersonCity = ref(selectedContact.value?.person?.city || '')
    let localPersonCounty = ref(selectedContact.value?.person?.county || '')
    let localPersonCountry = ref(selectedContact.value?.person?.country || '')
    let localPersonPhone = ref(selectedContact.value?.person?.phone || '')
    let localPersonMobile = ref(selectedContact.value?.person?.mobile || '')
    let localPersonFax = ref(selectedContact.value?.person?.fax || '')
    let localPersonEmail = ref(selectedContact.value?.person?.email || '')
    let localPersonEmail_2 = ref(selectedContact.value?.person?.email_2 || '')
    let localPersonUrl = ref(selectedContact.value?.person?.url || '')

    let localOrganisationName = ref(selectedContact.value?.organisation?.name || '')
    let localOrganisationTitleDescription = ref(
        selectedContact.value?.organisation?.titleDescription || ''
    )
    let localOrganisationDepartment = ref(selectedContact.value?.organisation?.department || '')
    let localOrganisationSubDepartment = ref(
        selectedContact.value?.organisation?.subDepartment || ''
    )
    let localOrganisationStreetName = ref(selectedContact.value?.organisation?.streetName || '')
    let localOrganisationStreetNumber = ref(selectedContact.value?.organisation?.streetNumber || '')
    let localOrganisationPoBox = ref(selectedContact.value?.organisation?.poBox || '')
    let localOrganisationZip = ref(selectedContact.value?.organisation?.zip || '')
    let localOrganisationCity = ref(selectedContact.value?.organisation?.city || '')
    let localOrganisationCounty = ref(selectedContact.value?.organisation?.county || '')
    let localOrganisationCountry = ref(selectedContact.value?.organisation?.country || '')
    let localOrganisationPhone = ref(selectedContact.value?.organisation?.phone || '')
    let localOrganisationMobile = ref(selectedContact.value?.organisation?.mobile || '')
    let localOrganisationFax = ref(selectedContact.value?.organisation?.fax || '')
    let localOrganisationEmail = ref(selectedContact.value?.organisation?.email || '')
    let localOrganisationUrl = ref(selectedContact.value?.organisation?.url || '')

    let localBillingTitle = ref(selectedContact.value?.billing?.title || '')
    let localBillingTitleDescription = ref(selectedContact.value?.billing?.titleDescription || '')
    let localBillingGreeting = ref(selectedContact.value?.billing?.greeting || '')
    let localBillingFirstName = ref(selectedContact.value?.billing?.firstName || '')
    let localBillingSecondName = ref(selectedContact.value?.billing?.secondName || '')
    let localBillingName = ref(selectedContact.value?.billing?.name || '')
    let localBillingFamilyName = ref(selectedContact.value?.billing?.familyName || '')
    let localBillingDepartment = ref(selectedContact.value?.billing?.department || '')
    let localBillingSubDepartment = ref(selectedContact.value?.billing?.subDepartment || '')
    let localBillingStreetName = ref(selectedContact.value?.billing?.streetName || '')
    let localBillingStreetNumber = ref(selectedContact.value?.billing?.streetNumber || '')
    let localBillingPoBox = ref(selectedContact.value?.billing?.poBox || '')
    let localBillingZip = ref(selectedContact.value?.billing?.zip || '')
    let localBillingCity = ref(selectedContact.value?.billing?.city || '')
    let localBillingCounty = ref(selectedContact.value?.billing?.county || '')
    let localBillingCountry = ref(selectedContact.value?.billing?.country || '')
    let localBillingPhone = ref(selectedContact.value?.billing?.phone || '')
    let localBillingMobile = ref(selectedContact.value?.billing?.mobile || '')
    let localBillingFax = ref(selectedContact.value?.billing?.fax || '')
    let localBillingEmail = ref(selectedContact.value?.billing?.email || '')
    let localBillingUrl = ref(selectedContact.value?.billing?.url || '')
    let localBillingAccountNumber = ref(selectedContact.value?.billing?.accountNumber || '')
    let localBillingCustomerNumber = ref(selectedContact.value?.billing?.customerNumber || '')
    let localBillingBankId = ref(selectedContact.value?.bankId || '')
    let localBillingSuppRemark = ref(selectedContact.value?.suppRemark || '')

    let localIsCustomer = ref(selectedContact.value?.isCustomer || '')
    let localIsSupplier = ref(selectedContact.value?.isSupplier || '')
    let localIsFriend = ref(selectedContact.value?.isFriend || '')
    let localIsObsolete = ref(selectedContact.value?.isObsolete || '')
    let localIsAkiw = ref(selectedContact.value?.isAkiw || '')
    let localIsPuhk = ref(selectedContact.value?.isPuhk || '')
    let localIsPtl = ref(selectedContact.value?.isPtl || '')
    let localIsEmployee = ref(selectedContact.value?.isEmployee || '')

    let localCreationTime = ref(selectedContact.value?.creationTime || '')
    let localCreatedBy = ref(selectedContact.value?.createdBy || '')
    let localCreatedUsing = ref(selectedContact.value?.createdUsing || '')
    let localModificationTime = ref(selectedContact.value?.modificationTime || '')
    let localAccountUuid = ref(selectedContact.value?.accountUuid || '')
    let localPersonUuid = ref(selectedContact.value?.personUuid || '')
    let localParentContactId = ref(selectedContact.value?.parentContactId || '')
    let localSyncWithCloud = ref(selectedContact.value?.syncWithCloud || '')

    // Computed property factory functions

    function computedProperty(propPath: string): ComputedRef<string> | WritableComputedRef<string> {
        const pathParts = propPath.split('.')
        const computedRef = computed({
            get: () => {
                let result: any = selectedContact.value
                for (const part of pathParts) {
                    // Check if result is either undefined or null before attempting to access its property
                    if (result === undefined || result === null) {
                        return ''
                    }
                    result = result[part]
                }
                return result || ''
            },
            set: (newValue) => {
                let obj: any = selectedContact.value
                for (let i = 0; i < pathParts.length - 1; i++) {
                    const part = pathParts[i]
                    // Ensure obj[part] is not only defined but also an object (not null or other types)
                    if (obj[part] === undefined || obj[part] === null) {
                        obj[part] = {}
                    }
                    obj = obj[part]
                }
                obj[pathParts[pathParts.length - 1]] = newValue
            },
        })

        return computedRef
    }

    localContactId = computedProperty('contactId') as Ref<string>

    localPersonTitle = computedProperty('person.title') as Ref<string>
    localPersonTitleDescription = computedProperty('person.titleDescription') as Ref<string>
    localPersonGender = computedProperty('person.gender') as Ref<string>
    localPersonGreeting = computedProperty('person.greeting') as Ref<string>
    localPersonFirstName = computedProperty('person.firstName') as Ref<string>
    localPersonSecondName = computedProperty('person.secondName') as Ref<string>
    localPersonFamilyName = computedProperty('person.familyName') as Ref<string>
    localPersonBirthDate = computedProperty('person.birthDate') as Ref<string>
    localPersonDepartment = computedProperty('person.department') as Ref<string>
    localPersonStreetName = computedProperty('person.streetName') as Ref<string>
    localPersonStreetNumber = computedProperty('person.streetNumber') as Ref<string>
    localPersonPoBox = computedProperty('person.poBox') as Ref<string>
    localPersonZip = computedProperty('person.zip') as Ref<string>
    localPersonCity = computedProperty('person.city') as Ref<string>
    localPersonCounty = computedProperty('person.county') as Ref<string>
    localPersonCountry = computedProperty('person.country') as Ref<string>
    localPersonPhone = computedProperty('person.phone') as Ref<string>
    localPersonMobile = computedProperty('person.mobile') as Ref<string>
    localPersonFax = computedProperty('person.fax') as Ref<string>
    localPersonEmail = computedProperty('person.email') as Ref<string>
    localPersonEmail_2 = computedProperty('person.email_2') as Ref<string>
    localPersonUrl = computedProperty('person.url') as Ref<string>

    localOrganisationName = computedProperty('organisation.name') as Ref<string>
    localOrganisationTitleDescription = computedProperty(
        'organisation.titleDescription'
    ) as Ref<string>
    localOrganisationDepartment = computedProperty('organisation.department') as Ref<string>
    localOrganisationSubDepartment = computedProperty('organisation.subDepartment') as Ref<string>
    localOrganisationStreetName = computedProperty('organisation.streetName') as Ref<string>
    localOrganisationStreetNumber = computedProperty('organisation.streetNumber') as Ref<string>
    localOrganisationPoBox = computedProperty('organisation.poBox') as Ref<string>
    localOrganisationZip = computedProperty('organisation.zip') as Ref<string>
    localOrganisationCity = computedProperty('organisation.city') as Ref<string>
    localOrganisationCounty = computedProperty('organisation.county') as Ref<string>
    localOrganisationCountry = computedProperty('organisation.country') as Ref<string>
    localOrganisationPhone = computedProperty('organisation.phone') as Ref<string>
    localOrganisationMobile = computedProperty('organisation.mobile') as Ref<string>
    localOrganisationFax = computedProperty('organisation.fax') as Ref<string>
    localOrganisationEmail = computedProperty('organisation.email') as Ref<string>
    localOrganisationUrl = computedProperty('organisation.url') as Ref<string>

    localBillingTitle = computedProperty('billing.title') as Ref<string>
    localBillingTitleDescription = computedProperty('billing.titleDescription') as Ref<string>
    localBillingGreeting = computedProperty('billing.greeting') as Ref<string>
    localBillingFirstName = computedProperty('billing.firstName') as Ref<string>
    localBillingSecondName = computedProperty('billing.secondName') as Ref<string>
    localBillingName = computedProperty('billing.name') as Ref<string>
    localBillingFamilyName = computedProperty('billing.familyName') as Ref<string>
    localBillingDepartment = computedProperty('billing.department') as Ref<string>
    localBillingSubDepartment = computedProperty('billing.subDepartment') as Ref<string>
    localBillingStreetName = computedProperty('billing.streetName') as Ref<string>
    localBillingStreetNumber = computedProperty('billing.streetNumber') as Ref<string>
    localBillingPoBox = computedProperty('billing.poBox') as Ref<string>
    localBillingZip = computedProperty('billing.zip') as Ref<string>
    localBillingCity = computedProperty('billing.city') as Ref<string>
    localBillingCounty = computedProperty('billing.county') as Ref<string>
    localBillingCountry = computedProperty('billing.country') as Ref<string>
    localBillingPhone = computedProperty('billing.phone') as Ref<string>
    localBillingMobile = computedProperty('billing.mobile') as Ref<string>
    localBillingFax = computedProperty('billing.fax') as Ref<string>
    localBillingEmail = computedProperty('billing.email') as Ref<string>
    localBillingUrl = computedProperty('billing.url') as Ref<string>
    localBillingAccountNumber = computedProperty('billing.accountNumber') as Ref<string>
    localBillingCustomerNumber = computedProperty('billing.customerNumber') as Ref<string>
    localBillingBankId = computedProperty('bankId') as Ref<string>
    localBillingSuppRemark = computedProperty('suppRemark') as Ref<string>

    localIsCustomer = computedProperty('isCustomer') as Ref<string>
    localIsSupplier = computedProperty('isSupplier') as Ref<string>
    localIsFriend = computedProperty('isFriend') as Ref<string>
    localIsObsolete = computedProperty('isObsolete') as Ref<string>
    localIsAkiw = computedProperty('isAkiw') as Ref<string>
    localIsPuhk = computedProperty('isPuhk') as Ref<string>
    localIsPtl = computedProperty('isPtl') as Ref<string>
    localIsEmployee = computedProperty('isEmployee') as Ref<string>

    localCreationTime = computedProperty('creationTime') as Ref<string>
    localCreatedBy = computedProperty('createdBy') as Ref<string>
    localCreatedUsing = computedProperty('createdUsing') as Ref<string>
    localModificationTime = computedProperty('modificationTime') as Ref<string>
    localAccountUuid = computedProperty('accountUuid') as Ref<string>
    localPersonUuid = computedProperty('personUuid') as Ref<string>
    localParentContactId = computedProperty('parentContactId') as Ref<string>
    localSyncWithCloud = computedProperty('syncWithCloud') as Ref<string>

    // default visibility of menus

    const showPerson = ref(true)
    const showOrganisation = ref(true)
    const showBilling = ref(true)
    const showMeta = ref(true)

    const contactFormRef = ref<FormWithValidation | null>(null)
    const personPanel = ref(null)

    // functions defined and used here

    function requiredFields() {
        // Fetch the relevant fields
        const firstName = localPersonFirstName.value.trim()
        const familyName = localPersonFamilyName.value.trim()
        const organisationName = localOrganisationName.value.trim()

        // Check conditions
        const hasNames = firstName && familyName // Both prename and surname are present
        const hasOrganisation = organisationName // Organisation name is present

        // Logic for required fields:
        // EITHER both firstName AND familyName must be present
        // OR organisationName must be present
        return hasNames || hasOrganisation
            ? true
            : 'Either both prename and surname OR organisation name must be present.'
    }

    async function submit() {
        // Check if contactFormRef is defined and has a validate method
        if (!contactFormRef.value || typeof contactFormRef.value.validate !== 'function') {
            console.error('Form reference is not available or validate method is not defined.')
            return
        }

        const isValid = await contactFormRef.value.validate()
        if (!isValid) {
            console.error('Form is invalid!')
            return
        }

        if (!selectedContact.value) {
            console.error('selectedContact.value is null or undefined.')
            return // Exit the function or handle the case accordingly
        }

        const formValid = await contactFormRef.value?.validate()
        const fieldsValid = requiredFields()

        // Ensure the validate method exists and is callable
        if (
            contactFormRef.value &&
            typeof contactFormRef.value?.validate === 'function' &&
            formValid &&
            fieldsValid === true
        ) {
            try {
                const isValid = await contactFormRef.value.validate()
                if (isValid) {
                    // Simplify setting boolean fields with a common function
                    updateBooleanFields(selectedContact)

                    // Decide between creating or updating a contact and execute the backend call

                    const action = selectedContact.value?.contactId
                        ? updateContact(selectedContact.value.contactId, selectedContact.value)
                        : selectedContact.value
                          ? createContact(selectedContact.value)
                          : null

                    // Navigate after successful operation
                    router.push('/contacts/')
                } else {
                    // Handle validation failure, e.g., by showing an error or focusing the first invalid field
                    handleValidationFailure()
                }
            } catch (error) {
                console.error('Error during form validation or submission:', error)
                // Handle any errors that occurred during validation or submission
            }
        } else {
            alert(
                'Bitte füllen Sie entweder den Vor- und Nachnamen oder den Organisationsnamen aus.'
            )
        }
    }

    function updateBooleanFields(selectedContact: any) {
        if (!selectedContact.value) selectedContact.value = {}

        localIsCustomer.value = localIsCustomer.value === 'Y' ? 'Y' : 'N'
        localIsSupplier.value = localIsSupplier.value === 'Y' ? 'Y' : 'N'
        localIsFriend.value = localIsFriend.value === 'Y' ? 'Y' : 'N'
        localIsObsolete.value = localIsObsolete.value === 'Y' ? 'Y' : 'N'
        localIsAkiw.value = localIsAkiw.value === 'Y' ? 'Y' : 'N'
        localIsPuhk.value = localIsPuhk.value === 'Y' ? 'Y' : 'N'
        localIsPtl.value = localIsPtl.value === 'Y' ? 'Y' : 'N'
        localIsEmployee.value = localIsEmployee.value === 'Y' ? 'Y' : 'N'

        selectedContact.value.isCustomer = localIsCustomer.value
        selectedContact.value.isSupplier = localIsSupplier.value
        selectedContact.value.isFriend = localIsFriend.value
        selectedContact.value.isObsolete = localIsObsolete.value
        selectedContact.value.isAkiw = localIsAkiw.value
        selectedContact.value.isPuhk = localIsPuhk.value
        selectedContact.value.isPtl = localIsPtl.value
        selectedContact.value.isEmployee = localIsEmployee.value
    }

    function handleValidationFailure() {
        console.log('Validation failed')
    }

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    onSubmit: _withModifiers(submit, ["prevent"]),
    ref_key: "contactFormRef",
    ref: contactFormRef
  }, {
    default: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, [
        _createElementVNode("span", {
          class: "cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showPerson.value = !showPerson.value))
        }, [
          _cache[85] || (_cache[85] = _createTextVNode(" Person ", -1)),
          (showPerson.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_2))
            : (_openBlock(), _createElementBlock("i", _hoisted_3))
        ])
      ]),
      (showPerson.value)
        ? (_openBlock(), _createBlock(_component_v_container, {
            key: 0,
            fluid: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                id: "localContactId",
                style: {"width":"20%","display":"inline-block"},
                class: "p-[5px]",
                label: "Kontakt ID",
                modelValue: _unref(localContactId),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(localContactId) ? (localContactId).value = $event : localContactId = $event)),
                readonly: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonTitle",
                style: {"width":"20%","display":"inline-block"},
                class: "p-[5px]",
                label: "Titel",
                modelValue: _unref(localPersonTitle),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(localPersonTitle) ? (localPersonTitle).value = $event : localPersonTitle = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonTitleDescription",
                style: {"width":"20%","display":"inline-block"},
                class: "p-[5px]",
                label: "Titel Beschreibung",
                modelValue: _unref(localPersonTitleDescription),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(localPersonTitleDescription) ? (localPersonTitleDescription).value = $event : localPersonTitleDescription = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonGender",
                style: {"width":"20%","display":"inline-block"},
                class: "p-[5px]",
                label: "M / F / D",
                modelValue: _unref(localPersonGender),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(localPersonGender) ? (localPersonGender).value = $event : localPersonGender = $event)),
                rules: [rules.gender]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonGreeting",
                style: {"width":"20%","display":"inline-block"},
                class: "p-[5px]",
                label: "Begrüssung",
                modelValue: _unref(localPersonGreeting),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(localPersonGreeting) ? (localPersonGreeting).value = $event : localPersonGreeting = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonFirstName",
                style: {"width":"25%","display":"inline-block"},
                class: "p-[5px]",
                label: "Vorname",
                modelValue: _unref(localPersonFirstName),
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(localPersonFirstName) ? (localPersonFirstName).value = $event : localPersonFirstName = $event)),
                rules: [rules.requiredFields, rules.maxLength],
                "validate-on": "input"
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonSecondName",
                style: {"width":"25%","display":"inline-block"},
                class: "p-[5px]",
                label: "Zweiter Vorname",
                modelValue: _unref(localPersonSecondName),
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(localPersonSecondName) ? (localPersonSecondName).value = $event : localPersonSecondName = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonFamilyName",
                style: {"width":"25%","display":"inline-block"},
                class: "p-[5px]",
                label: "Nachname",
                modelValue: _unref(localPersonFamilyName),
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(localPersonFamilyName) ? (localPersonFamilyName).value = $event : localPersonFamilyName = $event)),
                rules: [rules.requiredFields, rules.maxLength],
                "validate-on": "input"
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonBirthDate",
                style: {"width":"25%","display":"inline-block"},
                class: "p-[5px]",
                label: "Geburstag",
                modelValue: _unref(localPersonBirthDate),
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(localPersonBirthDate) ? (localPersonBirthDate).value = $event : localPersonBirthDate = $event)),
                "validate-on": "input",
                rules: [rules.validDate]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonDepartment",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "Departement",
                modelValue: _unref(localPersonDepartment),
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(localPersonDepartment) ? (localPersonDepartment).value = $event : localPersonDepartment = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonStreetName",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Strasse",
                modelValue: _unref(localPersonStreetName),
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(localPersonStreetName) ? (localPersonStreetName).value = $event : localPersonStreetName = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonStreetNumber",
                style: {"width":"16%","display":"inline-block"},
                class: "p-[5px]",
                label: "Nummer",
                modelValue: _unref(localPersonStreetNumber),
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(localPersonStreetNumber) ? (localPersonStreetNumber).value = $event : localPersonStreetNumber = $event)),
                rules: [rules.number, rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonPoBox",
                style: {"width":"25%","display":"inline-block"},
                class: "p-[5px]",
                label: "Postfach",
                modelValue: _unref(localPersonPoBox),
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(localPersonPoBox) ? (localPersonPoBox).value = $event : localPersonPoBox = $event)),
                rules: [rules.number, rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonZip",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "PLZ",
                modelValue: _unref(localPersonZip),
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(localPersonZip) ? (localPersonZip).value = $event : localPersonZip = $event)),
                rules: [rules.zipCode]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonCity",
                style: {"width":"25%","display":"inline-block"},
                class: "p-[5px]",
                label: "Stadt",
                modelValue: _unref(localPersonCity),
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(localPersonCity) ? (localPersonCity).value = $event : localPersonCity = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonCounty",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "Provinz / Kanton (Kürzel)",
                modelValue: _unref(localPersonCounty),
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(localPersonCounty) ? (localPersonCounty).value = $event : localPersonCounty = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonCountry",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "Land (Kürzel)",
                modelValue: _unref(localPersonCountry),
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(localPersonCountry) ? (localPersonCountry).value = $event : localPersonCountry = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _cache[86] || (_cache[86] = _createElementVNode("h2", { class: "mb-[2%] mt-5 text-xl font-normal" }, "Person Kontakt daten", -1)),
              _createVNode(_component_v_text_field, {
                id: "localPersonPhone",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Festnetz",
                modelValue: _unref(localPersonPhone),
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_isRef(localPersonPhone) ? (localPersonPhone).value = $event : localPersonPhone = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonMobile",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Mobil",
                modelValue: _unref(localPersonMobile),
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_isRef(localPersonMobile) ? (localPersonMobile).value = $event : localPersonMobile = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonFax",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Fax",
                modelValue: _unref(localPersonFax),
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_isRef(localPersonFax) ? (localPersonFax).value = $event : localPersonFax = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonEmail",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Email",
                modelValue: _unref(localPersonEmail),
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_isRef(localPersonEmail) ? (localPersonEmail).value = $event : localPersonEmail = $event)),
                rules: [rules.email, rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonEmail_2",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Email 2",
                modelValue: _unref(localPersonEmail_2),
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_isRef(localPersonEmail_2) ? (localPersonEmail_2).value = $event : localPersonEmail_2 = $event)),
                rules: [rules.email, rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonUrl",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "URL",
                modelValue: _unref(localPersonUrl),
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_isRef(localPersonUrl) ? (localPersonUrl).value = $event : localPersonUrl = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _cache[93] || (_cache[93] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("h2", _hoisted_4, [
        _createElementVNode("span", {
          class: "cursor-pointer",
          onClick: _cache[24] || (_cache[24] = ($event: any) => (showOrganisation.value = !showOrganisation.value))
        }, [
          _cache[87] || (_cache[87] = _createTextVNode(" Organisation ", -1)),
          (showOrganisation.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_5))
            : (_openBlock(), _createElementBlock("i", _hoisted_6))
        ])
      ]),
      (showOrganisation.value)
        ? (_openBlock(), _createBlock(_component_v_container, {
            key: 1,
            fluid: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                id: "localOrganisationName",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "Organisation Name",
                modelValue: _unref(localOrganisationName),
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_isRef(localOrganisationName) ? (localOrganisationName).value = $event : localOrganisationName = $event)),
                rules: [rules.requiredFields, rules.maxLength],
                "validate-on": "input"
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localOrganisationTitleDescription",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "Kurzbeschreibung",
                modelValue: _unref(localOrganisationTitleDescription),
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_isRef(localOrganisationTitleDescription) ? (localOrganisationTitleDescription).value = $event : localOrganisationTitleDescription = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localOrganisationDepartment",
                style: {"width":"33.333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Organisation Department",
                modelValue: _unref(localOrganisationDepartment),
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_isRef(localOrganisationDepartment) ? (localOrganisationDepartment).value = $event : localOrganisationDepartment = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localOrganisationSubDepartment",
                style: {"width":"33.333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Sub-Department",
                modelValue: _unref(localOrganisationSubDepartment),
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_isRef(localOrganisationSubDepartment) ? (localOrganisationSubDepartment).value = $event : localOrganisationSubDepartment = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localOrganisationStreetName",
                style: {"width":"16%","display":"inline-block"},
                class: "p-[5px]",
                label: "Strasse",
                modelValue: _unref(localOrganisationStreetName),
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_isRef(localOrganisationStreetName) ? (localOrganisationStreetName).value = $event : localOrganisationStreetName = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localOrganisationStreetNumber",
                style: {"width":"16%","display":"inline-block"},
                class: "p-[5px]",
                label: "Nummer",
                modelValue: _unref(localOrganisationStreetNumber),
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_isRef(localOrganisationStreetNumber) ? (localOrganisationStreetNumber).value = $event : localOrganisationStreetNumber = $event)),
                rules: [rules.number, rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localOrganisationPoBox",
                style: {"width":"25%","display":"inline-block"},
                class: "p-[5px]",
                label: "Organisation Postfach",
                modelValue: _unref(localOrganisationPoBox),
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_isRef(localOrganisationPoBox) ? (localOrganisationPoBox).value = $event : localOrganisationPoBox = $event)),
                rules: [rules.number, rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localOrganisationZip",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "PLZ",
                modelValue: _unref(localOrganisationZip),
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_isRef(localOrganisationZip) ? (localOrganisationZip).value = $event : localOrganisationZip = $event)),
                rules: [rules.zipCode, rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localOrganisationCity",
                style: {"width":"25%","display":"inline-block"},
                class: "p-[5px]",
                label: "Stadt",
                modelValue: _unref(localOrganisationCity),
                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_isRef(localOrganisationCity) ? (localOrganisationCity).value = $event : localOrganisationCity = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localOrganisationCounty",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "Organisation Provinz / Kanton (Kürzel)",
                modelValue: _unref(localOrganisationCounty),
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_isRef(localOrganisationCounty) ? (localOrganisationCounty).value = $event : localOrganisationCounty = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localOrganisationCountry",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "Land (Kürzel)",
                modelValue: _unref(localOrganisationCountry),
                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_isRef(localOrganisationCountry) ? (localOrganisationCountry).value = $event : localOrganisationCountry = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _cache[88] || (_cache[88] = _createElementVNode("h2", { class: "mb-[2%] mt-5 text-xl font-normal" }, "Organisation Kontakt daten", -1)),
              _createVNode(_component_v_text_field, {
                id: "localOrganisationPhone",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Festnetz",
                modelValue: _unref(localOrganisationPhone),
                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_isRef(localOrganisationPhone) ? (localOrganisationPhone).value = $event : localOrganisationPhone = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localOrganisationMobile",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Mobil",
                modelValue: _unref(localOrganisationMobile),
                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_isRef(localOrganisationMobile) ? (localOrganisationMobile).value = $event : localOrganisationMobile = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localOrganisationFax",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Fax",
                modelValue: _unref(localOrganisationFax),
                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_isRef(localOrganisationFax) ? (localOrganisationFax).value = $event : localOrganisationFax = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localOrganisationEmail",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "Email",
                modelValue: _unref(localOrganisationEmail),
                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_isRef(localOrganisationEmail) ? (localOrganisationEmail).value = $event : localOrganisationEmail = $event)),
                rules: [rules.email, rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localOrganisationUrl",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "URL",
                modelValue: _unref(localOrganisationUrl),
                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_isRef(localOrganisationUrl) ? (localOrganisationUrl).value = $event : localOrganisationUrl = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _cache[94] || (_cache[94] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("h2", _hoisted_7, [
        _createElementVNode("span", {
          class: "cursor-pointer",
          onClick: _cache[41] || (_cache[41] = ($event: any) => (showBilling.value = !showBilling.value))
        }, [
          _cache[89] || (_cache[89] = _createTextVNode(" Rechnungen ", -1)),
          (showBilling.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_8))
            : (_openBlock(), _createElementBlock("i", _hoisted_9))
        ])
      ]),
      (showBilling.value)
        ? (_openBlock(), _createBlock(_component_v_container, {
            key: 2,
            fluid: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                id: "localBillingTitle",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Rechnungadresse Titel",
                modelValue: _unref(localBillingTitle),
                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_isRef(localBillingTitle) ? (localBillingTitle).value = $event : localBillingTitle = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingTitleDescription",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Titel Beschreibung",
                modelValue: _unref(localBillingTitleDescription),
                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_isRef(localBillingTitleDescription) ? (localBillingTitleDescription).value = $event : localBillingTitleDescription = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingGreeting",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Begrussung",
                modelValue: _unref(localBillingGreeting),
                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_isRef(localBillingGreeting) ? (localBillingGreeting).value = $event : localBillingGreeting = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingFirstName",
                style: {"width":"25%","display":"inline-block"},
                class: "p-[5px]",
                label: "Vorname",
                modelValue: _unref(localBillingFirstName),
                "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_isRef(localBillingFirstName) ? (localBillingFirstName).value = $event : localBillingFirstName = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingSecondName",
                style: {"width":"25%","display":"inline-block"},
                class: "p-[5px]",
                label: "Zweiter Vorname",
                modelValue: _unref(localBillingSecondName),
                "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_isRef(localBillingSecondName) ? (localBillingSecondName).value = $event : localBillingSecondName = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingName",
                style: {"width":"25%","display":"inline-block"},
                class: "p-[5px]",
                label: "Nachname",
                modelValue: _unref(localBillingName),
                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_isRef(localBillingName) ? (localBillingName).value = $event : localBillingName = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingFamilyName",
                style: {"width":"25%","display":"inline-block"},
                class: "p-[5px]",
                label: "Famillienname",
                modelValue: _unref(localBillingFamilyName),
                "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_isRef(localBillingFamilyName) ? (localBillingFamilyName).value = $event : localBillingFamilyName = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingDepartment",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Rechnungadresse Department",
                modelValue: _unref(localBillingDepartment),
                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (_isRef(localBillingDepartment) ? (localBillingDepartment).value = $event : localBillingDepartment = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingSubDepartment",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Sub-Department",
                modelValue: _unref(localBillingSubDepartment),
                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_isRef(localBillingSubDepartment) ? (localBillingSubDepartment).value = $event : localBillingSubDepartment = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingStreetName",
                style: {"width":"16%","display":"inline-block"},
                class: "p-[5px]",
                label: "Strasse",
                modelValue: _unref(localBillingStreetName),
                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_isRef(localBillingStreetName) ? (localBillingStreetName).value = $event : localBillingStreetName = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingStreetNumber",
                style: {"width":"16%","display":"inline-block"},
                class: "p-[5px]",
                label: "Nummer",
                modelValue: _unref(localBillingStreetNumber),
                "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (_isRef(localBillingStreetNumber) ? (localBillingStreetNumber).value = $event : localBillingStreetNumber = $event)),
                rules: [rules.number, rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingPoBox",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Rechnundadresse Postfach",
                modelValue: _unref(localBillingPoBox),
                "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => (_isRef(localBillingPoBox) ? (localBillingPoBox).value = $event : localBillingPoBox = $event)),
                rules: [rules.number, rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingZip",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "PLZ",
                modelValue: _unref(localBillingZip),
                "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => (_isRef(localBillingZip) ? (localBillingZip).value = $event : localBillingZip = $event)),
                rules: [rules.zipCode, rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingCity",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Stadt",
                modelValue: _unref(localBillingCity),
                "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (_isRef(localBillingCity) ? (localBillingCity).value = $event : localBillingCity = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingCounty",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "Rechnungsadresse Provinz / Kanton (Kürzel)",
                modelValue: _unref(localBillingCounty),
                "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => (_isRef(localBillingCounty) ? (localBillingCounty).value = $event : localBillingCounty = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingCountry",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "Land (Kürzel)",
                modelValue: _unref(localBillingCountry),
                "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (_isRef(localBillingCountry) ? (localBillingCountry).value = $event : localBillingCountry = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _cache[90] || (_cache[90] = _createElementVNode("h2", { class: "mb-[2%] mt-5 text-xl font-normal" }, "Rechnungen Kontaktdaten", -1)),
              _createVNode(_component_v_text_field, {
                id: "localBillingPhone",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Festnetz",
                modelValue: _unref(localBillingPhone),
                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => (_isRef(localBillingPhone) ? (localBillingPhone).value = $event : localBillingPhone = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingMobile",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Mobil",
                modelValue: _unref(localBillingMobile),
                "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => (_isRef(localBillingMobile) ? (localBillingMobile).value = $event : localBillingMobile = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingFax",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Fax",
                modelValue: _unref(localBillingFax),
                "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => (_isRef(localBillingFax) ? (localBillingFax).value = $event : localBillingFax = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingEmail",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "Email",
                modelValue: _unref(localBillingEmail),
                "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => (_isRef(localBillingEmail) ? (localBillingEmail).value = $event : localBillingEmail = $event)),
                rules: [rules.email, rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingUrl",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "URL",
                modelValue: _unref(localBillingUrl),
                "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => (_isRef(localBillingUrl) ? (localBillingUrl).value = $event : localBillingUrl = $event)),
                rules: [rules.maxLength]
              }, null, 8, ["modelValue", "rules"]),
              _cache[91] || (_cache[91] = _createElementVNode("h2", { class: "mb-[2%] mt-5 text-xl font-normal" }, "Rechnungen Bankverbindung", -1)),
              _createVNode(_component_v_text_field, {
                id: "localBillingAccountNumber",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "Rechnungsadresse Kontonummer",
                modelValue: _unref(localBillingAccountNumber),
                "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => (_isRef(localBillingAccountNumber) ? (localBillingAccountNumber).value = $event : localBillingAccountNumber = $event)),
                rules: [rules.maxLength80]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingCustomerNumber",
                style: {"width":"25%","display":"inline-block"},
                class: "p-[5px]",
                label: "Kundennummer",
                modelValue: _unref(localBillingCustomerNumber),
                "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => (_isRef(localBillingCustomerNumber) ? (localBillingCustomerNumber).value = $event : localBillingCustomerNumber = $event)),
                rules: [rules.maxLength80]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingBankId",
                style: {"width":"25%","display":"inline-block"},
                class: "p-[5px]",
                label: "Bank ID",
                modelValue: _unref(localBillingBankId),
                "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => (_isRef(localBillingBankId) ? (localBillingBankId).value = $event : localBillingBankId = $event)),
                rules: [rules.bankId]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                id: "localBillingSuppRemark",
                style: {"width":"100%","display":"inline-block"},
                class: "p-[5px]",
                label: "Bemerkungen",
                modelValue: _unref(localBillingSuppRemark),
                "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => (_isRef(localBillingSuppRemark) ? (localBillingSuppRemark).value = $event : localBillingSuppRemark = $event)),
                rules: [rules.maxLength65535]
              }, null, 8, ["modelValue", "rules"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _cache[95] || (_cache[95] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("h2", _hoisted_10, [
        _createElementVNode("span", {
          class: "cursor-pointer",
          onClick: _cache[67] || (_cache[67] = ($event: any) => (showMeta.value = !showMeta.value))
        }, [
          _cache[92] || (_cache[92] = _createTextVNode(" Metadaten ", -1)),
          (showMeta.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_11))
            : (_openBlock(), _createElementBlock("i", _hoisted_12))
        ])
      ]),
      (showMeta.value)
        ? (_openBlock(), _createBlock(_component_v_container, {
            key: 3,
            fluid: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_checkbox, {
                id: "localIsCustomer",
                "false-value": "N",
                "true-value": "Y",
                style: {"width":"25%","display":"inline-block"},
                color: "#db0720",
                class: "p-[5px]",
                modelValue: _unref(localIsCustomer),
                "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => (_isRef(localIsCustomer) ? (localIsCustomer).value = $event : localIsCustomer = $event)),
                label: "Kunde"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_checkbox, {
                id: "localIsSupplier",
                "false-value": "N",
                "true-value": "Y",
                style: {"width":"25%","display":"inline-block"},
                color: "#db0720",
                class: "p-[5px]",
                modelValue: _unref(localIsSupplier),
                "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => (_isRef(localIsSupplier) ? (localIsSupplier).value = $event : localIsSupplier = $event)),
                label: "Lieferant"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_checkbox, {
                id: "localIsFriend",
                "false-value": "N",
                "true-value": "Y",
                style: {"width":"25%","display":"inline-block"},
                color: "#db0720",
                class: "p-[5px]",
                modelValue: _unref(localIsFriend),
                "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => (_isRef(localIsFriend) ? (localIsFriend).value = $event : localIsFriend = $event)),
                label: "Freund"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_checkbox, {
                id: "localIsObsolete",
                "false-value": "N",
                "true-value": "Y",
                style: {"width":"25%","display":"inline-block"},
                color: "#db0720",
                class: "p-[5px]",
                modelValue: _unref(localIsObsolete),
                "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => (_isRef(localIsObsolete) ? (localIsObsolete).value = $event : localIsObsolete = $event)),
                label: "Obsolete"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_checkbox, {
                id: "localIsAkiw",
                "false-value": "N",
                "true-value": "Y",
                style: {"width":"25%","display":"inline-block"},
                color: "#db0720",
                class: "p-[5px]",
                modelValue: _unref(localIsAkiw),
                "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => (_isRef(localIsAkiw) ? (localIsAkiw).value = $event : localIsAkiw = $event)),
                label: "AKIW"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_checkbox, {
                id: "localIsPuhk",
                "false-value": "N",
                "true-value": "Y",
                style: {"width":"25%","display":"inline-block"},
                color: "#db0720",
                class: "p-[5px]",
                modelValue: _unref(localIsPuhk),
                "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => (_isRef(localIsPuhk) ? (localIsPuhk).value = $event : localIsPuhk = $event)),
                label: "PUHK"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_checkbox, {
                id: "localIsPtl",
                "false-value": "N",
                "true-value": "Y",
                style: {"width":"25%","display":"inline-block"},
                color: "#db0720",
                class: "p-[5px]",
                modelValue: _unref(localIsPtl),
                "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => (_isRef(localIsPtl) ? (localIsPtl).value = $event : localIsPtl = $event)),
                label: "PTL"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_checkbox, {
                id: "localIsEmployee",
                "false-value": "N",
                "true-value": "Y",
                style: {"width":"25%","display":"inline-block"},
                color: "#db0720",
                class: "p-[5px]",
                modelValue: _unref(localIsEmployee),
                "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => (_isRef(localIsEmployee) ? (localIsEmployee).value = $event : localIsEmployee = $event)),
                label: "Mitarbeiter*in"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                id: "localCreationTime",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Erstellungsdatum",
                modelValue: _unref(localCreationTime),
                "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => (_isRef(localCreationTime) ? (localCreationTime).value = $event : localCreationTime = $event)),
                readonly: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                id: "localCreatedBy",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Erstellt von",
                modelValue: _unref(localCreatedBy),
                "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => (_isRef(localCreatedBy) ? (localCreatedBy).value = $event : localCreatedBy = $event)),
                readonly: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                id: "localCreatedUsing",
                style: {"width":"33.3333%","display":"inline-block"},
                class: "p-[5px]",
                label: "Erstellt mit",
                modelValue: _unref(localCreatedUsing),
                "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => (_isRef(localCreatedUsing) ? (localCreatedUsing).value = $event : localCreatedUsing = $event)),
                readonly: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                id: "localModificationTime",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "Letzte Änderung",
                modelValue: _unref(localModificationTime),
                "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => (_isRef(localModificationTime) ? (localModificationTime).value = $event : localModificationTime = $event)),
                readonly: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                id: "localAccountUuid",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "Account UUID",
                modelValue: _unref(localAccountUuid),
                "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => (_isRef(localAccountUuid) ? (localAccountUuid).value = $event : localAccountUuid = $event)),
                readonly: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                id: "localPersonUuid",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "Person UUID",
                modelValue: _unref(localPersonUuid),
                "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => (_isRef(localPersonUuid) ? (localPersonUuid).value = $event : localPersonUuid = $event)),
                readonly: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                id: "localParentContactId",
                style: {"width":"50%","display":"inline-block"},
                class: "p-[5px]",
                label: "Parent Contact ID",
                modelValue: _unref(localParentContactId),
                "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => (_isRef(localParentContactId) ? (localParentContactId).value = $event : localParentContactId = $event)),
                readonly: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_checkbox, {
                id: "localSyncWithCloud",
                modelValue: _unref(localSyncWithCloud),
                "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => (_isRef(localSyncWithCloud) ? (localSyncWithCloud).value = $event : localSyncWithCloud = $event)),
                color: "#db0720",
                label: "Sync with Cloud"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(FullButton, {
        onClick: _cache[84] || (_cache[84] = ($event: any) => (submit())),
        width: "100",
        title: "Speichern",
        colour: "white",
        class: "pt-5",
        "data-cy": "submit"
      })
    ]),
    _: 1
  }, 512))
}
}

})